import React, { useEffect, useState } from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButtons,
  IonMenuButton,
  IonButton,
  IonIcon,
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonCardContent,
  IonItem,
  IonLabel,
  IonSelect,
  IonSelectOption,
  IonSpinner,
  IonAlert,
  IonAccordionGroup,
  IonAccordion,
  IonBadge,
  IonDatetimeButton,
  IonModal,
  IonDatetime,
  IonBackButton
} from '@ionic/react';
import {
  refreshOutline,
  timeOutline,
  receiptOutline,
  personOutline,
  cashOutline,
  barbell,
  notifications,
  cashSharp
} from 'ionicons/icons';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Divider,
  Typography,
  CircularProgress
} from '@mui/material';
import { formatCurrencyN, formattedDates, formatToNaira, getTodaysDate } from '../../../common/utils_t';
import { orderHistory } from '../../../api/orders/orders';
import { Link } from 'react-router-dom';

interface OrderItem {
  item_status: string;
  price: string;
  product_id: string;
  product_name: string;
  productName: string;
  quantity: string;
  total_amount: string;
}

interface Order {
  items: OrderItem[];
  order_by: string;
  order_code: string;
  order_date: string;
  order_id: string;
  order_status: string;
  payable_amount: string;
  mode_of_payment: string | null;
}

const StewardOrderReports: React.FC = () => {
  const todaysDate = getTodaysDate();
  const [filterStatus, setFilterStatus] = useState<string>('all');
  const [isLoading, setIsLoading] = useState(false);
  const [orders, setOrders] = useState<Order[]>([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [startDate, setStartDate] = useState(todaysDate);
  const [endDate, setEndDate] = useState(todaysDate);
  const [showStartDateModal, setShowStartDateModal] = useState(false);
  const [showEndDateModal, setShowEndDateModal] = useState(false);

  // const mockOrders: Order[] = [
  //   {
  //     items: [
  //       {
  //         item_status: "WAITING",
  //         price: "121.00",
  //         product_id: "prodID94d39c1abcb9482e0459bc138f4b021c",
  //         product_name: "okay",
  //         quantity: "2",
  //         total_amount: "242.00"
  //       },
  //       {
  //         product_id: 'prodIDc7f466078900c20229d137cfdaa1fd4d',
  //         quantity: '3',
  //         product_name: 'bread',
  //         price: '12.00',
  //         total_amount: '36.00',
  //         item_status: 'WAITING'
  //       },
  //       {
  //         product_id: 'prodIDf3d3786ffcd1b4218399b8d79d6cc327',
  //         quantity: '1',
  //         product_name: 'garri',
  //         price: '12.00',
  //         total_amount: '12.00',
  //         item_status: 'WAITING'
  //       }
  //     ],
  //     mode_of_payment: null,
  //     order_by: "051a5287abf8578a53ff37b6fd907767",
  //     order_code: "ORD-0c50a5-719582",
  //     order_date: "2025-04-22 15:04:58",
  //     order_id: "ord-0c50a53747",
  //     order_status: "WAITING",
  //     payable_amount: "278.00"
  //   }
  // ];



  useEffect(()=>{
    const fetchOrders = async() => {


      const data ={
        start_date :startDate,
        end_date :endDate,
      }
      const response = await orderHistory(data)
  
      console.log(response.data)
      setIsLoading(true);
      setTimeout(() => {
        setOrders(response.data);
        setIsLoading(false);
        setAlertMessage(`Found ${orders.length} orders`);
        setShowAlert(true);
      }, 1000);
    };

    fetchOrders()
  },[endDate])
  

  const handleStartDateChange = (e: CustomEvent) => setStartDate(e.detail.value);
  const handleEndDateChange = (e: CustomEvent) => setEndDate(e.detail.value);

  // const getStatusColor = (status: string) => {
  //   switch(status?.toLowerCase()) {
  //     case 'waiting': return 'warning';
  //     case 'completed': return 'success';
  //     case 'cancelled': return 'danger';
  //     default: return 'medium';
  //   }
  // };
 

  return (
    <IonPage>

       <IonHeader className="app-header">
              <IonToolbar className="app-toolbar">
                <IonButtons slot="start">
                  <IonBackButton defaultHref="/" />
                </IonButtons>
                <IonTitle className="app-title">Orders Report</IonTitle>
                <IonButtons slot="end">
            <IonButton >
              <Link to={`/steward/notification`}>
              <IonIcon icon={notifications} slot="icon-only"  />
              </Link>
            </IonButton>
          </IonButtons>
              </IonToolbar>
            </IonHeader>
      
      {/* <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>Order Reports</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={fetchOrders}>
              <IonIcon icon={refreshOutline} slot="icon-only" />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader> */}

      <IonContent className="ion-padding">
        <IonGrid className="ion-no-padding">
          {/* Filters Section */}
          <IonRow>
            {/* <IonCol size="12" sizeMd="6">
              <IonItem className="ion-no-padding" lines="none">
                <IonLabel position="stacked">Start Date</IonLabel>
                <IonDatetimeButton datetime="startDate" onClick={() => setShowStartDateModal(true)} />
                <IonModal 
                  isOpen={showStartDateModal} 
                  onDidDismiss={() => setShowStartDateModal(false)}
                  className="date-modal"
                >
                  <IonDatetime
                    id="startDate"
                    value={startDate}
                    presentation="date"
                    onIonChange={handleStartDateChange}
                  />
                  <IonButton expand="block" onClick={() => setShowStartDateModal(false)}>
                    Confirm
                  </IonButton>
                </IonModal>
              </IonItem>
            </IonCol>

            <IonCol size="12" sizeMd="6">
              <IonItem className="ion-no-padding" lines="none">
                <IonLabel position="stacked">End Date</IonLabel>
                <IonDatetimeButton datetime="endDate" onClick={() => setShowEndDateModal(true)} />
                <IonModal 
                  isOpen={showEndDateModal} 
                  onDidDismiss={() => setShowEndDateModal(false)}
                  className="date-modal"
                >
                  <IonDatetime
                    id="endDate"
                    value={endDate}
                    presentation="date"
                    onIonChange={handleEndDateChange}
                  />
                  <IonButton expand="block" onClick={() => setShowEndDateModal(false)}>
                    Confirm
                  </IonButton>
                </IonModal>
              </IonItem>
            </IonCol> */}

<div className="date-container">
            <IonItem>
              <IonLabel position="stacked">Start Date</IonLabel>
              <IonDatetimeButton
                datetime="startDate"
                onClick={() => setShowStartDateModal(true)}
              >
                {startDate || "Select Start Date"}
              </IonDatetimeButton>
              <IonModal
                isOpen={showStartDateModal}
                onDidDismiss={() => setShowStartDateModal(false)}
                keepContentsMounted={true}
              >
                <IonDatetime
                  id="startDate"
                  value={startDate}
                  presentation="date"
                  onIonChange={handleStartDateChange}
                  preferWheel={true}
                />
                <IonButton
                  expand="full"
                  onClick={() => setShowStartDateModal(false)}
                >
                  Done
                </IonButton>
              </IonModal>
            </IonItem>

            {/* End Date */}
            <IonItem>
              <IonLabel position="stacked">End Date</IonLabel>
              <IonDatetimeButton
                datetime="endDate"
                onClick={() => setShowEndDateModal(true)}
              >
                {endDate || "Select End Date"}
              </IonDatetimeButton>
              <IonModal
                isOpen={showEndDateModal}
                onDidDismiss={() => setShowEndDateModal(false)}
                keepContentsMounted={true}
              >
                <IonDatetime
                  id="endDate"
                  value={endDate}
                  presentation="date"
                  onIonChange={handleEndDateChange}
                  preferWheel={true}
                />
                <IonButton
                  expand="full"
                  onClick={() => setShowEndDateModal(false)}
                >
                  Done
                </IonButton>
              </IonModal>
            </IonItem>
          </div>

          </IonRow>

          <IonRow>
            <IonCol size="12">
              <IonItem className="ion-no-padding" lines="none">
                <IonLabel>Order Status</IonLabel>
                <IonSelect 
                  value={filterStatus} 
                  onIonChange={e => setFilterStatus(e.detail.value)}
                  interface="action-sheet"
                >
                  <IonSelectOption value="all">All</IonSelectOption>
                  <IonSelectOption value="WAITING">Waiting</IonSelectOption>
                  <IonSelectOption value="COMPLETED">Completed</IonSelectOption>
                  <IonSelectOption value="CANCELLED">Cancelled</IonSelectOption>
                </IonSelect>
              </IonItem>
            </IonCol>
          </IonRow>

          {/* Results Section */}
          <IonRow>
            <IonCol size="12">
              <Typography variant="h6" component="div" sx={{ mb: 2, fontWeight: 'bold' }}>
                Order Results
              </Typography>

              {isLoading ? (
                <Box display="flex" justifyContent="center" py={4}>
                  <CircularProgress />
                </Box>
              ) : orders.length > 0 ? (
                <IonAccordionGroup>
                  {orders.map((order) => (
                    <IonAccordion key={order.order_id} className="order-accordion">
                      <IonItem slot="header" lines="none" className="order-header">
                        <IonLabel>
                          <Typography fontWeight="bold">{order.order_code}</Typography>
                          <Typography variant="body2" color="text.secondary">
                            <IonIcon icon={timeOutline} size="small" /> {formattedDates(order.order_date)}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            <IonIcon icon={cashSharp} size="small" />      {formatToNaira(order.payable_amount)}
                            Total Amount:

                          </Typography>
                        </IonLabel>
                        <IonBadge 
                        // color={getStatusColor(order.order_status)}
                        >
                          {order.order_status}
                        </IonBadge>
                      </IonItem>

                      <div slot="content" className="ion-padding order-content">
                        <IonCard className="order-card">
                          <IonCardContent>
                            <Box mb={2}>
                              <Typography variant="subtitle2" gutterBottom>
                                <IonIcon icon={personOutline} /> Customer: {order.order_by}
                              </Typography>
                              <Typography variant="subtitle2">
                                <IonIcon icon={cashOutline} /> Total: {formatToNaira(order.payable_amount)}
                              </Typography>
                            </Box>

                            <Divider sx={{ my: 2 }} />

                            <Typography variant="subtitle1" gutterBottom>
                              <IonIcon icon={receiptOutline} /> Order Items
                            </Typography>

                            <TableContainer component={Paper} elevation={0} sx={{ mb: 2 }}>
                              <Table size="small">
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Product</TableCell>
                                    <TableCell align="right">Qty</TableCell>
                                    <TableCell align="right">Price</TableCell>
                                    <TableCell align="right">Total</TableCell>
                                    <TableCell align="center">Status</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {order.items.map((item, index) => (
                                    <TableRow key={`${item.product_id}-${index}`}>
                                      <TableCell>{item.productName}</TableCell>
                                      <TableCell align="right">{item.quantity}</TableCell>
                                      <TableCell align="right">{formatToNaira(item.price)}</TableCell>
                                      <TableCell align="right">{formatToNaira(item.total_amount)}</TableCell>
                                      <TableCell align="center">
                                        <Chip 
                                          label={item.item_status} 
                                          size="small"
                                          // color={getStatusColor(item.item_status)}
                                        />
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </IonCardContent>
                        </IonCard>
                      </div>
                    </IonAccordion>
                  ))}
                </IonAccordionGroup>
              ) : (
                <IonCard>
                  <IonCardContent>
                    <Typography align="center" color="text.secondary">
                      No orders found
                    </Typography>
                  </IonCardContent>
                </IonCard>
              )}
            </IonCol>
          </IonRow>

          {/* Summary Section */}
          {orders.length > 0 && (
            <IonRow>
              <IonCol size="12">
                <IonCard className="summary-card">
                  <IonCardContent>
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="subtitle1">
                        Total Orders: {orders.length}
                      </Typography>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Grand Total: {formatToNaira(
                          orders.reduce((sum, order) => sum + parseFloat(order.payable_amount), 0).toString()
                        )}
                      </Typography>
                    </Box>
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          )}
        </IonGrid>

        <IonAlert
          isOpen={showAlert}
          onDidDismiss={() => setShowAlert(false)}
          header={orders.length > 0 ? 'Report Generated' : 'No Results'}
          message={alertMessage}
          buttons={['OK']}
        />
      </IonContent>
    </IonPage>
  );
};

export default StewardOrderReports;